import React, { useEffect, useState } from "react";
import DataTable from 'react-data-table-component'
import { MdArrowBackIosNew } from "react-icons/md";

import axios from 'axios';

const RegistrationView = () => {

  const[search, setSearch] = useState("");
  const[times, setTimes] = useState([]);
  const[filtertimes, setFilterTimes] = useState([]);

  const getTime = async () =>{
      try {
        const response = await axios.get('https://talabulilm.in/registrationView.php')
        setTimes(response.data)
        setFilterTimes(response.data)
      } catch (error) {
        console.log(error)
      }
  };
  const columns = [
    {
      name:'Date',
      selector:row => row.Date,
      sortable:true
    },
    {
      name:'UserName',
      selector:row => row.UserName
    },
    {
      name:'Name',
      selector:row => row.Name
    },
    {
      name:'Code',
      selector:row => row.Code
    },
    // {
    //   name:'Actions',
    //   cell:row=><button className='customBtn' onClick={()=>{alert(row.kfta);}}>Edit</button>
    // }
  ]

useEffect(()=> {
  getTime();
},[])

useEffect(()=>{
 const result = times.filter(time => {
  return time.date.toLowerCase().match(search.toLowerCase());
 });
 setFilterTimes(result)
},[search])
  return (
    <div className='contain'>
       <div className="page-header">
          <span className="backBtn" onClick={()=> window.history.back()}>
            <MdArrowBackIosNew />
          </span>
          <div className="page-header__content">
            <h2 className="pagetitle">RegistraionView </h2>
          </div>
       </div>
        <DataTable 
         columns={columns} 
         data={filtertimes} 
         pagination 
         fixedHeader
         fixedHeaderScrollHeight='460px'
         selectableRowsHighlight  
         highlightOnHover
        //  subHeader
        //  subHeaderComponent = {
        //   <input 
        //    type='text' 
        //    placeholder="Search here..." 
        //    value={search}
        //    onChange={(e)=>setSearch(e.target.value)}
           
        //   />
        //  }
        
         />
    </div>
  )
}

export default RegistrationView;